import moment from "moment";
import React, { useEffect, useRef, useState } from "react"
import { Alert, Button, Card, Col, ConfigProvider, DatePicker, Form, Input, InputNumber, Modal, Row, Select, Table, Tabs } from "antd";
import Highlighter from 'react-highlight-words';
import { BarcodeOutlined, FormOutlined, SearchOutlined, UndoOutlined } from '@ant-design/icons';
import { CollectionsService } from "@gtpl/shared-services/finance";
import { Link, useHistory } from "react-router-dom";
import { IdRequest } from "@gtpl/shared-models/gtpl";
import { AlertMessages } from "@gtpl/shared-utils/alert-messages";
import { PayableFilterRequest, PayableRequest, RmInvoiceDataForPayablesReq, RmPayblesReq } from "@gtpl/shared-models/finance";
import { render } from "react-dom";
import { CompanyTypeEnum, CurrencyDto, PlantsDropDown } from "@gtpl/shared-models/masters";
import { BankDetailsService, CurrencyService, TaxesService, UnitcodeService } from "@gtpl/shared-services/masters";
import { RMTypePaybleEnum, UserRequestDto } from "@gtpl/shared-models/common-models";
import dayjs from 'dayjs';
import { Radio } from 'antd';
export function Payables(){
      const [page, setPage] = useState(1);
      const [pageSize, setPageSize] = useState<number>(100);
      const [data, setData] = useState([])
      const [searchText, setSearchText] = useState("");
      const [searchedColumn, setSearchedColumn] = useState("");
      const searchInput = useRef(null);
      const { TabPane } = Tabs;  
      const { Option } = Select;
      const [invoices, setInvoices] = useState([])
      const [invoiceType, setInvoiceType] = useState(undefined)
      const [selectedInvoices, setSlectedInvoices] = useState(undefined)
      const [vendors, setVendors] = useState([])
      const createdUser = localStorage.getItem('createdUser')
      const service = new CollectionsService()
      const [totalInvAmt, setTotalInvAmt] = useState<number>(0);
      const [taxAmt, setTaxAmt] = useState<number>(0);
      const [deductionAmt, setDeductionAmt] = useState<number>(0);
      const [totalAmt, setTotalAmt] = useState<number>(0);
      const [totQty, setTotQty] = useState<number>(0);
      const [tds, setTds] = useState<boolean>(false);
      const [paidAmt, setPaidAmt] = useState<number>(0);
      const [isPaymentModal, setIsPaymentModal] = useState<boolean>(false);
      const [itemsData, setItemsData] = useState([])
      const [batches, setBatches] = useState([]);
      const [plantData, setPlantData] = useState<PlantsDropDown[]>([]);
      const unitsService = new UnitcodeService();
      const [taxData,setTaxesData]= useState([])
      const taxService = new TaxesService();
      const [selectedRMType, setSelectedRMType] = useState<any>();
      const [selectedInvoice, setSelectedInvoice] = useState<any>();
      const [selectedTax, setSelectedTax] = useState<any>();
      const [rmInvoiceAmount, setRmInvoiceAmount] = useState<number>(0);
      const [rmTaxAmount, setRmTaxAmount] = useState<number>(0);
      const [rmDutyAmount, setRmDutyAmount] = useState<number>(0);
      const [rmFinalAmount, setRmFinalAmount] = useState<number>(0);
      const [taxPercentage, setTaxPercentage] = useState<number>(0);
      const [dutyPercentage, setDutyPercentage] = useState<number>(0);
        const [currency, setCurrency] = useState<CurrencyDto[]>([]);
          const[bankDetails,setBankDetails] = useState<any[]>([])
  const bankDetailsService = new BankDetailsService()
  const currencyService = new CurrencyService();


      useEffect(() => {
        getAllPlants();
        getCurrencyData();
        getBankDetails()
      }, []);

    const getAllTaxes= () => {
      const user = new UserRequestDto(JSON.parse(localStorage.getItem('username')))
      taxService.getAllTaxes(user).then(res => {
        if (res.status) {
          setTaxesData(res.data);
        } else {
          if (res.intlCode) {
            setTaxesData([]);
              AlertMessages.getErrorMessage(res.internalMessage);
          } else {
         AlertMessages.getErrorMessage(res.internalMessage);
          }
        }
      }).catch(err => {
        setTaxesData([]);
       AlertMessages.getErrorMessage(err.message);
      })
    }

    const [form] = Form.useForm();
    const [paymentForm] = Form.useForm();

    const getRmSuppliers =()=>{
            service.getRmSuppliers().then(res=>{
                if(res.status){
                  setVendors(res.data)
                }else{
                  setVendors([])
                }
              })
          }

    const getPackingVendors =()=>{
    const req = new PayableFilterRequest()
    if(form.getFieldValue('invoiceId')!=undefined){
        req.supplierId = form.getFieldValue('invoiceId')
            }         
             service.getPackingVendors(req).then(res=>{
            if(res.status){
              setVendors(res.data)
            }else{
              setVendors([])
            }
          })
          
        }

        const getBankDetails = () => {
  bankDetailsService.getAllBankDetailsInfo().then(res=>{
    if(res.status){
      setBankDetails(res.data)
    }
  })
}
       
          const getCurrencyData = () => {
    currencyService.getAllActiveCurrencys().then((res) => {
      if (res.status) {
        setCurrency(res.data);
        // setCurrency(res.data);
      } else {
        // if (res.intlCode) {
        //   AlertMessages.getErrorMessage(res.internalMessage);
        // } else {
        //   AlertMessages.getErrorMessage(res.internalMessage);
        // }
        setCurrency([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setCurrency([]);
    });
  }

         const getAllPlants = () => {
        unitsService.getAllMainPlants().then((res) => {
        if (res.status) {
            setPlantData(res.data);
        } else {
            setPlantData([]);
        }
        }).catch(err => {
                AlertMessages.getErrorMessage(err.message);
                setPlantData([]);
            })
        }
      
      const getRMInvoices =  () =>{
        const req = new IdRequest()
        service.getRmInvoices().then(res=>{
            if(res.status){
              setInvoices(res.data)
              
            }else{
              setInvoices([])
            }
          })
        }
      
      const getPackingInvoices =  () =>{
      const req = new PayableFilterRequest()
        if(form.getFieldValue('vendorId')!=undefined){
              req.supplierId = form.getFieldValue('vendorId')
          }       
        if(form.getFieldValue('unit')!=undefined){
            req.unit = form.getFieldValue('unit')
                }  
                  service.getPackingInvoices(req).then(res=>{
                if(res.status){
                  setInvoices(res.data)
                }else{
                  setInvoices([])
                }
              })     
            }
        
      const getData =  (val) =>{
      const req = new PayableFilterRequest()
      if(form.getFieldValue('invoiceId')!=undefined){
        req.invoiceNumber = form.getFieldValue('invoiceId')
          }
            if(form.getFieldValue('vendorId')!=undefined){
        req.supplierId = form.getFieldValue('vendorId')
            }
             if(form.getFieldValue('unit')!=undefined){
        req.unit = form.getFieldValue('unit')
            }
           const rmNewReq=new RmPayblesReq()
            rmNewReq.rmType = selectedRMType
          {val ==='RM'?

           service.getRmInvoiceDataForPayables(rmNewReq).then(res=>{
            if(res.status){
              setData(res.data)
            }else{
              setData([])
              AlertMessages.getErrorMessage('No Data Found')
            }
          }):
          service.getPackingPayableInvoices(req).then(res=>{
            if(res.status){
              setData(res.data)
            }else{
              setData([])
              AlertMessages.getErrorMessage('No Data Found')
            }
          })     
         }
        }

        function handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
      };
    
      function handleReset(clearFilters) {
        clearFilters();
        setSearchText('');
      };

     const getColumnSearchProps = (dataIndex: string) => ({
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          size="small"
          style={{ width: 90 }}
          onClick={() => {
            handleReset(clearFilters);
            setSearchedColumn(dataIndex);
            confirm({ closeDropdown: true });
          }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        type="search"
        style={{ color: filtered ? "#1890ff" : undefined }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : (
          text
        )
      ) : null,
  })

    const packingItemColumns: any[] = [
    {
      title: 'S No', dataIndex: 'sNo', render: (text, object, index) => {
        if (index == data.length) {
          return null;
        } else {
          return index + 1
        }
      },
    
    },
    {
      title: 'PO Number', 
     dataIndex: 'poNumber',
     render: (text: any, record: any) => { return record.poNumber ? record.poNumber : '-' } ,
     sorter: (a, b) => a.poNumber.localeCompare(b.poNumber),
     sortDirections: ['descend', 'ascend'],
    ...getColumnSearchProps('poNumber')},
    {
       title: 'Invoice Number', 
      dataIndex: 'invoiceNumber',
        render: (text: any, record: any) => { return record.invoiceNumber ? record.invoiceNumber : '-' } ,
        sorter: (a, b) => a.invoiceNumber.localeCompare(b.invoiceNumber),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('invoiceNumber')},
      {
       title: 'Invoice Date', 
      dataIndex: 'invoiceDate',
        render: (text: any, record: any) => { 
                    console.log(moment(text.invoiceDate).format('DD-MM-YYYY'),'ppppppppppppppppp');
          return record.invoiceDate ? moment(record.invoiceDate).format('DD-MM-YYYY') : '-' } ,
        sorter: (a, b) => a.invoiceDate.localeCompare(b.invoiceDate),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('invoiceDate')},
    {
       title: 'Item', 
      dataIndex: 'item',
        sorter: (a, b) => a.item-b.item,
      sortDirections: ['descend', 'ascend'],
     },
    {
      title: 'Quantity', 
        align:'right',
     dataIndex: 'quantity',
    },
    {
     title: 'Unit Price', 
        align:'right',
    dataIndex: 'unitPrice',
    },
    {
        title: 'Amount', 
        align:'right',
       dataIndex: 'quantity',
 
         render: (text: any, record: any) => { return record.quantity ?((Number(record.quantity)*Number(record.unitPrice))-Number(record.discount) ).toFixed(2): '-' },
       },
       {
     title: 'Discount', 
             align:'right',
    dataIndex: 'discount',
    render: (text: any, record: any) => { return record.discount ?`${record.discount}(${(Number(record.discountPer))}%)` : '-' },

    },
      {
     title: 'Tax', 
    dataIndex: 'taxPer',
    render: (text: any, record: any) => { return record.taxPer ?`${(Number(record.taxPer))}%` : '-' },

    },
{
     title: 'Tax Amount',
             align:'right',
    dataIndex: 'taxPer',
             render: (text: any, record: any) => { return record.taxPer ?(Number(((Number(record.quantity)*Number(record.unitPrice))-Number(record.discount))*(Number(record.taxPer)/100)).toFixed(2)) : '-' },
}, 
    {
       title: 'Tax Deduction', 
               align:'right',
       dataIndex: 'deduction',
        render: (_: any, record: any) => {
    const deduction = (Number(record.deduction)    || 0)*0.001;
    return record.deduction
      ? deduction.toFixed(2)
      : '0';
  },
       },
    {
  title: 'Invoice',
          align:'right',
  dataIndex: 'invoiceAmount',
  render: (_: any, record: any) => {
    const qty       = Number(record.quantity)    || 0;
    const price     = Number(record.unitPrice)   || 0;
    const taxRate   = (Number(record.taxPer)      || 0) / 100;
    const deduction = (Number(record.deduction)    || 0)*0.001;
    const discount = Number(record.discount) || 0 
    const amount   = (qty * price)-discount;
    const taxValue = amount * taxRate;
    const invoice  = amount + taxValue - deduction;
    return price
      ? invoice.toFixed(2)
      : '-';
  },
}, 
  ]

  const itemColumns = packingItemColumns;

  const packingColumns: any[] = [
    {
      title: 'S No', dataIndex: 'sNo', render: (text, object, index) => {
        if (index == data.length) {
          return null;
        } else {
          return index + 1
        }
      },
    
    },
     {
      title: 'Vendor', 
     dataIndex: 'vendor',
     render: (text: any, record: any) => { return record.vendor ? record.vendor : '-' } ,
     sorter: (a, b) => a.vendor.localeCompare(b.vendor),
     sortDirections: ['descend', 'ascend'],
     },
    {
      title: 'PO Number', 
     dataIndex: 'poNumber',
     render: (text: any, record: any) => { return record.poNumber ? record.poNumber : '-' } ,
     sorter: (a, b) => a.poNumber.localeCompare(b.poNumber),
     sortDirections: ['descend', 'ascend'],
    ...getColumnSearchProps('poNumber')},
    {
       title: 'Invoice Number', 
      dataIndex: 'invoiceNumber',
        render: (text: any, record: any) => { return record.invoiceNumber ? record.invoiceNumber : '-' } ,
        sorter: (a, b) => a.invoiceNumber.localeCompare(b.invoiceNumber),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('invoiceNumber')},
      {
       title: 'Invoice Date', 
      dataIndex: 'invoiceDate',
        render: (text: any, record: any) => { 
                    console.log(moment(text.invoiceDate).format('DD-MM-YYYY'),'ppppppppppppppppp');
          return record.invoiceDate ? moment(record.invoiceDate).format('DD-MM-YYYY') : '-' } ,
        sorter: (a, b) => a.invoiceDate.localeCompare(b.invoiceDate),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('invoiceDate')},
    {
  title: 'Invoice',
          align:'right',
  dataIndex: 'invoiceAmount',
  render: (_: any, record: any) => {
    return record.amount
      ? Number((record.amount)-(record.deduction*0.001)).toFixed(2)
      : '-';
  },
},
{
   title: 'Action',
  dataIndex: 'invoiceAmount',
  render:(val,rec)=>{
      return(<FormOutlined title="Payment" onClick={() => payment(rec)}/> )
  }
}
  ]
  const rmColumns: any[] = [
    {
      title: 'S No', dataIndex: 'sNo', render: (text, object, index) => {
        if (index == data.length) {
          return null;
        } else {
          return index + 1
        }
      },
    },
     {
      title: 'Supplier', 
     dataIndex: 'vendor',
     render: (text: any, record: any) => { return record.vendor?record.vendor:'-' } ,
     },
    {
       title: 'Invoice Number', 
      dataIndex: 'invoiceNumber',

        render: (text: any, record: any) => { return record.invoiceNumber ? record.invoiceNumber : '-' } ,
        sorter: (a, b) => a.invoiceNumber.localeCompare(b.invoiceNumber),
      sortDirections: ['descend', 'ascend'],
    },
{
  title: 'Invoice Date',
  dataIndex: 'invoiceDate',

  ...getColumnSearchProps('invoiceDate'),

  render: (text) =>
    text ? moment.utc(text).format('DD-MM-YYYY') : '-',
},
    {
      title: 'Quantity', 
      align:'right',
     dataIndex: 'quantity',
     render:(_,record)=>formatDecimal(record.quantity)

    },
  {
  title: 'Invoice Amount',
          align:'right',
  dataIndex: 'invoiceAmount',
  render:(_,record)=>formatDecimal(record.invoiceAmount)
},
...((selectedRMType === "IMPORT PAYABLE" || selectedRMType === "DOMESTIC")
  ? [
     
      {
        title: "Paid Amount",
        dataIndex: "paidAmount",
        align: "right",
        render: (_: any, record: any) =>
          formatDecimal(record.paidAmount),
      },
      {
        title: "Balance Amount",
        dataIndex: "balanceAmount",
        align: "right",
        render: (_: any, record: any) =>
          formatDecimal(record.balanceAmount),
      },
       {
        title: "Status",
        dataIndex: "status",
        render: (_: any, record: any) => record.status || "-",
      },
    ] 
  : []),
{
   title: 'Action',
  dataIndex: 'invoiceAmount',
  render:(val,rec)=>{
      return(<FormOutlined title="Payment" onClick={() => payment(rec)}/> )
  }
}
  ]

  const invoiceColumns = invoiceType === 'PACKING' ? packingColumns : rmColumns;

  // const payment = (rowData) =>{
  //   setIsPaymentModal(true)
  //   setSelectedInvoice(rowData);
  //   getPaymentData(rowData)
  // }

  const payment = (rowData) => {

    paymentForm.resetFields();

    setRmTaxAmount(0);
    setRmDutyAmount(0);

    setSelectedTax(undefined);

    setRmInvoiceAmount(Number(rowData.invoiceAmount));

    setRmFinalAmount(Number(rowData.invoiceAmount));

    setSelectedInvoice(rowData);

        paymentForm.setFieldsValue({
        invoiceAmount: Number(rowData.invoiceAmount)
    });

    setIsPaymentModal(true);

}


      const getPaymentData=(rowData)=>{
      paymentForm.setFieldsValue({invoiceId:rowData.invoiceNumber})
      paymentForm.setFieldsValue({vendorId:rowData.vendorId})
      paymentForm.resetFields(['receivedDate'])
       const rmReq = new PayableFilterRequest()
        rmReq.invoiceNumber = rowData.invoiceNumber
        rmReq.supplierId = rowData.vendorId
        const rmNewReq=new RmPayblesReq()
        // rmNewReq.invoiceNumber = rowData.invoiceNumber
        rmNewReq.rmType = selectedRMType
      {invoiceType ==='RM'?
      service.getRmInvoiceDataForPayables(rmNewReq)
      .then(res=>{
      if(res.status){
        const invoice=res.data[0];
        setSelectedInvoice(invoice);
        setRmInvoiceAmount(Number(invoice.invoiceAmount));
        setRmFinalAmount(Number(invoice.invoiceAmount));
        paymentForm.setFieldsValue({
            supplier:invoice.vendor,
            invoiceNo:invoice.invoiceNumber,
            invoiceAmount:invoice.invoiceAmount
        });
    }
}):
          service.getPackingPayables(rmReq).then(res=>{
            if(res.status){
              setItemsData(res.data)
               const totalInvoiceAmount = res.data.reduce((sum, invoice) => {
                const inv = Number(invoice.amount)
                 const taxAmt = Number(Number(invoice.amount)*Number((invoice.taxPer)/100))
                const deduction = invoice.tdsApplicable?(Number(invoice.deduction)*0.001):0
            return sum + Number((inv-deduction) || 0)
          }, 0);
          const totalAmount = res.data.reduce((sum, invoice) => {
            return sum + Number((Number(invoice.quantity)*Number(invoice.unitPrice)) || 0);
          }, 0);
          const totalQuantity = res.data.reduce((sum, invoice) => {
            return sum + Number(invoice.quantity || 0);
          }, 0);
          const totDed = res.data.reduce((sum, invoice) => {
            return sum + Number(invoice.tdsApplicable?Number(invoice.deduction)*0.001: 0);
          }, 0);
          const taxAmt = res.data.reduce((sum, invoice) => {
            return sum + Number(((Number(invoice.quantity)*Number(invoice.unitPrice))-Number(invoice.discount))*Number((invoice.taxPer)/100));
          }, 0);
        const payment = res.data[0]?.paidAmount
        setTotalInvAmt(totalInvoiceAmount)
        setTotQty(totalQuantity)
        setTotalAmt(totalAmount)
        setDeductionAmt(totDed)
        setTaxAmt(taxAmt)
        setPaidAmt(res.data[0]?.paidAmount)
    paymentForm.setFieldsValue({ 'due':(Math.round(Number(totalInvoiceAmount-Number(payment)))) });
            }else{
              setItemsData([])
            }
          })     
         }
}

const formatDecimal = (value: any) => {
    if (value === null || value === undefined)
        return "-";
    return Number(value).toFixed(2);
}

  const invoiceTypeChange=(val) =>{
    form.resetFields(['vendorId','invoiceId'])
    setInvoiceType(val)
    paymentForm.resetFields()
    if(val != null|| val!= undefined)
    if (val === 'RM') {
    form.resetFields(['vendorId','invoiceId','rmType']);
    setData([]);
    setItemsData([]);
    getAllTaxes();
    getRMInvoices();
    } else {
    form.resetFields(['vendorId','invoiceId','unit']);
    getData(val)
    getPackingVendors();
    getPackingInvoices();
    }
    }

    const rmTypeChange = (value: string) => {
    setSelectedRMType(value);
    setData([]);
    form.resetFields(['invoiceId']);
    }

    const invoiceChange=(val,rec) =>{
    setSlectedInvoices(rec.invoiceNum)
    }

    const taxChange = (value: number) => {
    const tax = taxData.find((x: any) => x.taxId === value);
    if (!tax) return;
    setSelectedTax(tax);
    const percentage = Number(tax.taxPercentage);
    setTaxPercentage(percentage);
    const taxAmount = (Number(rmInvoiceAmount) * percentage) / 100;
    setRmTaxAmount(taxAmount);
    setRmFinalAmount(Number(rmInvoiceAmount) + taxAmount);
    paymentForm.setFieldsValue({taxAmount: taxAmount.toFixed(2)});
    }

    const dutyChange = (value: number) => {
    const percentage = Number(value || 0);
    setDutyPercentage(percentage);
    const dutyAmount =(Number(rmInvoiceAmount) * percentage) / 100;
    setRmDutyAmount(dutyAmount);
    setRmFinalAmount(Number(rmInvoiceAmount) + dutyAmount);
    paymentForm.setFieldsValue({dutyAmount: dutyAmount.toFixed(2)});
    }

    const save=async (val)=>{
    const values = await paymentForm.validateFields();
    if (invoiceType == "PACKING") { 
    const req =new PayableRequest(
    1,
    invoiceType,             
    totQty,
    totalAmt,
    Number(deductionAmt)  || 0,
    totalInvAmt,
    values.payment,
    createdUser,         
    values.vendorId,               
    values.receivedDate,           
    values.invoiceId,
    '',
    tds,
   Math.round(totalInvAmt-values.payment-paidAmt),
   itemsData[0]?.invoiceDate
  )
  
    service.savePayables(req).then(res=>{
      if(res.status){
        AlertMessages.getSuccessMessage(res.internalMessage)
        setIsPaymentModal(false)
        paymentForm.resetFields()
        getData(invoiceType);
      }else{
        AlertMessages.getErrorMessage(res.internalMessage)
      }
    })
  }else{
     const req = new PayableRequest();
    req.invoiceType = invoiceType;
    req.createdUser = createdUser;
    req.invoiceNumber = selectedInvoice.invoiceNumber;
    req.vendorId = selectedInvoice.vendorId;
    req.receivedDate = values.receivedDate;
    req.payment = values.payment;
    req.remarks = values.remarks;
    req.rmType = selectedRMType;
    req.invoiceNumber = selectedInvoice.invoiceNumber;
    req.invoiceDate = selectedInvoice.invoiceDate;
    req.quantity = selectedInvoice.quantity;
    req.invoiceAmount = selectedInvoice.invoiceAmount;
    if (selectedRMType == "IGST") {
        req.taxId = values.taxId
        req.taxAmount = rmTaxAmount;
    }

    if (selectedRMType == "DUTY PAID") {
        req.dutyPercentage =values.dutyPercentage;
        req.dutyAmount =rmDutyAmount;
    }
    if (selectedRMType === "IMPORT PAYABLE") {
    req.transactionType = values.transactionType;
    req.currency = values.currency;
    req.exchangeRate = values.exchangeRate;
    req.receivedAmountInr = values.receivedAmountInr;
    req.bankAccount = values.bankAccount;
    req.bankCharges = values.bankCharges;
    req.buyerShortPayment = values.buyerShortPayment;
    req.invoiceAmount = values.invoiceAmount;
    req.finalAmount = selectedInvoice.invoiceAmount;
}
if(selectedRMType === "DOMESTIC") {

  req.transactionType = values.transactionType;
  req.bankAccount = values.bankAccount;
   req.bankCharges = Number(values.bankCharges) || 0;
    req.buyerShortPayment = Number(values.buyerShortPayment) || 0;
    req.invoiceAmount = Number(selectedInvoice?.invoiceAmount) || 0;
  // req.finalAmount = selectedInvoice.invoiceAmount;
}
const balance = Number(
    selectedInvoice?.balanceAmount ?? selectedInvoice?.invoiceAmount
);
const paymentAmount = Number(values.payment) || 0;
if (paymentAmount > balance) {
    AlertMessages.getErrorMessage(
        `Payment Amount cannot exceed Balance Amount (${balance.toFixed(2)})`
    );
    return;
}
if (
    values.transactionType === "PART PAYMENT" &&
    Math.abs(paymentAmount - balance) < 0.01
) {
    AlertMessages.getErrorMessage(
        `You are paying the complete Balance Amount (${balance.toFixed(2)}). Please select Full Payment.`
    );
    return;
}

if (
    values.transactionType === "FULL PAYMENT" &&
    Math.abs(paymentAmount - balance) > 0.01
) {
    AlertMessages.getErrorMessage(
        `Payment Amount (${paymentAmount.toFixed(2)}) should be equal to Balance Amount (${balance.toFixed(2)}) to make Full Payment.`
    );
    return;
}
    service.savePayables(req).then(res => {
            if (res.status) {
                AlertMessages.getSuccessMessage(res.internalMessage);
                paymentForm.resetFields();

                setSelectedInvoice(undefined);

                setSelectedTax(undefined);

                setRmInvoiceAmount(0);

                setRmTaxAmount(0);

                setRmDutyAmount(0);

                setRmFinalAmount(0);

                setIsPaymentModal(false);
                getData(invoiceType);
            }
            else {
                AlertMessages.getErrorMessage(res.internalMessage);
            }
        });
      }
      }

    const handlePaymentChange = (val) => {
      const payment = val || 0;
      const due = totalInvAmt - payment-paidAmt;
      paymentForm.setFieldsValue({ 'due':(Math.round(due)) });
    };

    const resetFilter = () => {
    if (invoiceType === 'RM') {
        form.resetFields(['rmType']);
        setSelectedRMType(undefined);
        setData([]);
    } else {
        form.resetFields(['vendorId','invoiceId','unit']);
        getData(invoiceType);
    }
    }
   const calculateInvoiceAmount = (paymentValue?: number) => {
  const payment =
    paymentValue !== undefined
      ? Number(paymentValue) || 0
      : Number(paymentForm.getFieldValue('payment')) || 0;

  const bankCharges =
    Number(paymentForm.getFieldValue('bankCharges')) || 0;

  const buyerShortPayment =
    Number(paymentForm.getFieldValue('buyerShortPayment')) || 0;

  // DOMESTIC
if (selectedRMType === "DOMESTIC") {
 paymentForm.setFieldsValue({
        invoiceAmount: Number(selectedInvoice?.invoiceAmount) || 0
    });


    return;
}

  // Existing IMPORT PAYABLE logic
  const exchangeRate =
    Number(paymentForm.getFieldValue("exchangeRate")) || 1;

  const receivedAmountInr = payment * exchangeRate;

  const invoiceAmount =
    receivedAmountInr +
    bankCharges +
    buyerShortPayment;

  const balance = Number(
    selectedInvoice?.balanceAmount ?? selectedInvoice?.invoiceAmount
  );

  if (invoiceAmount > balance) {
    paymentForm.setFields([
      {
        name: "invoiceAmount",
        errors: [
          `Invoice Amount cannot exceed Balance Amount (${balance})`
        ]
      }
    ]);
  } else {
    paymentForm.setFields([
      {
        name: "invoiceAmount",
        errors: []
      }
    ]);
  }

  paymentForm.setFieldsValue({
    receivedAmountInr,
    invoiceAmount,
  });
};

  return(
    <>
    <Card
  title={<span style={{ color: 'white',fontSize:"20px" }}>Payables</span>}
  style={{ textAlign: 'center', width: '100%' }}
  headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
  extra={<Link to="/payables-view"><Button className="panel_button">View</Button></Link>}>

  <Form layout={'vertical'} form={form}   onFinish={async()=>{
    const values = await form.validateFields();
    if(invoiceType=="RM"){
        const req=new PayableFilterRequest();
        req.rmType=values.rmType;
                const rmNewReq=new RmPayblesReq()
        rmNewReq.rmType = selectedRMType
        service.getRmInvoiceDataForPayables(rmNewReq).then(res=>{
            if(res.status){
                setData(res.data);
            }else{
                setData([]);
                AlertMessages.getErrorMessage("No Data Found");
            }
        });
    }else{
        getPackingInvoices();
        getData(invoiceType);
    }
  }}>

    <Row gutter={24}>
      <Col xs={24} sm={24} md={8} lg={6} xl={4}>
        <Form.Item name="invoiceType" label="Invoice Type">
          <Select allowClear showSearch onSelect={invoiceTypeChange} dropdownMatchSelectWidth={false} placeholder="Select Invoice Type">
            <Option value="PACKING" key="PACKING">PACKING</Option>
            <Option value="RM" key="RM">RM</Option>
          </Select>
        </Form.Item>
      </Col>
    {invoiceType !== undefined && (
    <>
    {invoiceType === 'PACKING' ? (
      <>
        <Col xs={24} sm={24} md={8} lg={6} xl={4}>
          <Form.Item label="Vendor" name="vendorId">
            <Select
              allowClear
              showSearch
              placeholder="Select Vendor"
              optionFilterProp="children"
              dropdownMatchSelectWidth={false}
              showArrow
            >
              {vendors.map((data) => (
                <Option key={data.vendorId} value={data.vendorId}>
                  {data.vendor}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} sm={24} md={5} lg={5} xl={5}>
          <Form.Item
            name="invoiceId"
            label="Invoice Number"
          >
            <Select
              allowClear
              showSearch
              placeholder="Select Invoice Number"
              optionFilterProp="children"
              onChange={invoiceChange}
              dropdownMatchSelectWidth={false}
              showArrow
            >
              {invoices.map((data) => (
                <Option
                  key={data.invoiceNumber}
                  value={data.invoiceNumber}
                >
                  {data.invoiceNumber}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
          <Form.Item name="unit" label="Unit">
            <Select
              showSearch
              allowClear
              placeholder="Select Unit"
            >
              {plantData.map((dropData) => (
                <Option
                  key={dropData.plantId}
                  value={dropData.plantId}
                >
                  {dropData.plantCode}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </>
    ) : (
      <>
        <Col xs={24} sm={24} md={8} lg={6} xl={4}>
          <Form.Item label="RM Type" name="rmType">
            <Select
              allowClear
              showSearch
              placeholder="Select RM Type"
              optionFilterProp="children"
              dropdownMatchSelectWidth={false}
              showArrow
              onChange={rmTypeChange}
            >
              {Object.values(RMTypePaybleEnum).map((data) => (
                <Option
                  key={data}
                  value={data}
                >
                  {data}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </>
    )}
  </>
)}

                  <Col span={2}>
      <Form.Item>
          <><Button type="primary" htmlType="submit"  style={{ marginTop: '35px'}} size="small">
                    Search
                  </Button></>
        </Form.Item>
                </Col>
         <Col span={2}>
      <Form.Item>
        <Button  style={{ marginTop: '35px' }} size="small" onClick={resetFilter}>
                      Reset
                    </Button>
        </Form.Item>
              </Col>
    </Row>   
         {data.length > 0 && (
      <Table
        columns={invoiceColumns} 
        dataSource={data}
      />
    )}
</Form>

<Modal visible={isPaymentModal} 
onCancel={() => {

    paymentForm.resetFields();

    setSelectedInvoice(undefined);

    setSelectedTax(undefined);

    setRmInvoiceAmount(0);

    setRmTaxAmount(0);

    setRmDutyAmount(0);

    setRmFinalAmount(0);

    setIsPaymentModal(false);

}}onOk={()=>setIsPaymentModal(false)} width={'90%'} footer={false}>
  <Card size="small">
     <Form layout={'vertical'} form={paymentForm} onFinish={save}>
    <Row gutter={24}>
      {invoiceType != undefined && (
        <>
          {invoiceType == 'PACKING' ? (
            <Col xs={24} sm={24} md={8} lg={6} xl={4}>
              <Form.Item label="Vendor" name="vendorId" rules={[{ required: true, message: 'Missing Vendor' }]}>
                <Select
                  allowClear
                  showSearch
                  placeholder="Select Vendor"
                  optionFilterProp="children"
                  dropdownMatchSelectWidth={false}
                  showArrow
                  disabled={true}
                >
                  {vendors.map((data) => {
                    return <Option key={data.vendorId} value={data.vendorId}>{data.vendor}</Option>;
                  })}
                </Select>
              </Form.Item>
            </Col>
          ) : (<></>)}

          {invoiceType=='PACKING' && (
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Form.Item
                name="invoiceId"
                label="Invoice Number"
                rules={[{ required: true, message: 'Invoice Number is required' }]}
              >
                <Select
                  allowClear
                  showSearch
                  placeholder="Select Invoice Number"
                  optionFilterProp="children"
                  onChange={invoiceChange}
                  dropdownMatchSelectWidth={false}
                  showArrow
                  disabled={true}
                >
                  {invoices.map((data) => {
                    return <Option key={data.invoiceNumber} value={data.invoiceNumber} invoiceNumber={data.invoiceNumber}>{data.invoiceNumber}</Option>;
                  })}
                </Select>
              </Form.Item>
            </Col>
          )}

      {invoiceType == 'RM' && (
      <>
        <Col xs={24} sm={24} md={5} lg={6} xl={6}>
            <Form.Item label="Supplier">
                <Input
                    value={selectedInvoice?.vendor}
                    disabled
                />
            </Form.Item>
        </Col>

        <Col xs={24} sm={24} md={5} lg={6} xl={6}>
            <Form.Item label="Invoice Number">
                <Input
                    value={selectedInvoice?.invoiceNumber}
                    disabled
                />
            </Form.Item>
        </Col>

        <Col xs={24} sm={24} md={3} lg={6} xl={6}>
            <Form.Item label="Final Amount">
                <InputNumber
                    value={rmInvoiceAmount}
                    disabled
                    style={{width:'100%'}}
                />
            </Form.Item>
        </Col>
{(selectedRMType === "IMPORT PAYABLE" ||
  selectedRMType === "DOMESTIC") && (
      <Col span={24}>
    <div
      style={{
        textAlign: "right",
        fontWeight: 600,
        color: "#1677ff",
        marginBottom: 12,
      }}
    >
      Balance Amount :
      <span style={{ color: "#ff4d4f", marginLeft: 5 }}>
        {Number(selectedInvoice?.balanceAmount ?? selectedInvoice?.invoiceAmount).toFixed(2)}
      </span>
    </div>
  </Col>
)}
        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <Form.Item
                label="Payment Date"
                name="receivedDate"
                initialValue={dayjs()}
                rules={[{ required:true,message:"Select Payment Date" }]}>
                <DatePicker
                    style={{width:'100%'}}
                    format="DD-MM-YYYY"
                />
            </Form.Item>
        </Col>

        {
            selectedRMType=="IGST" &&
            <>
                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item
                        label="Tax"
                        name="taxId"
                        rules={[
                            {
                                required:true,
                                message:"Select Tax"
                            }
                        ]}
                    >
                        <Select
                            placeholder="Select Tax"
                            onChange={taxChange}
                        >
                            {
                                taxData
                                .filter(x=>x.taxCategory=="Central")
                                .map(item=>
                                    <Option
                                        key={item.taxId}
                                        value={item.taxId}
                                    >
                                        {item.taxName}
                                    </Option>
                                )
                            }
                        </Select>
                    </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item
                        label="Tax Amount"
                        name="taxAmount"
                    >
                        <InputNumber
                            style={{width:'100%'}}
                            disabled
                        />
                    </Form.Item>
                </Col>
                <Col md={6} lg={6} xl={6}>
<Form.Item
label="Final Amount"
>

<InputNumber

disabled

style={{
width:"100%"
}}

value={rmFinalAmount}

/>

</Form.Item>

</Col>

            </>

        }

        {
            selectedRMType=="DUTY PAID" &&

            <>

                <Col xs={24} sm={24} md={6} lg={6} xl={6}>

                    <Form.Item
                        label="Duty %"
                        name="dutyPercentage"
                        rules={[
                            {
                                required:true,
                                message:"Enter Duty Percentage"
                            }
                        ]}
                    >

                        <InputNumber

                            min={0}

                            max={100}

                            style={{width:'100%'}}

                            onChange={dutyChange}

                        />

                    </Form.Item>

                </Col>

                <Col xs={24} sm={24} md={6} lg={6} xl={6}>

                    <Form.Item
                        label="Duty Amount"
                        name="dutyAmount"
                    >

                        <InputNumber

                            disabled

                            style={{width:'100%'}}

                        />

                    </Form.Item>

                </Col>
                <Col md={6} lg={6} xl={6}>

<Form.Item
label="Final Amount"
>

<InputNumber

disabled

style={{
width:"100%"
}}

value={rmFinalAmount}

/>

</Form.Item>

</Col>

            </>

        }
{selectedRMType !== "IMPORT PAYABLE" &&
 selectedRMType !== "DOMESTIC" && (          <>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <Form.Item
                label="Payment Amount"
                name="payment"
              rules={[
              {required:true,message:"Enter Payment"},
              {validator(_,value){
              let maxAmount=rmInvoiceAmount;
              if(selectedRMType=="IGST"){maxAmount+=rmTaxAmount;}
              if(selectedRMType=="DUTY PAID"){maxAmount+=rmDutyAmount;}
              if(Number(value)>Number(maxAmount)){
              return Promise.reject(
              `Payment cannot exceed ${maxAmount.toFixed(2)}`
              )
              }
              return Promise.resolve();
              }
              }
              ]}
            >
                <InputNumber style={{width:'100%'}} min={0}  />
            </Form.Item>
        </Col>
          </>
        )}
              {(selectedRMType == "IMPORT PAYABLE" ||
  selectedRMType == "DOMESTIC") && (

                <>
                                       <Col xs={24} sm={24} md={6} lg={6} xl={6}>
    <Form.Item
        name="transactionType"
        label="Transaction Type"
        initialValue="PART PAYMENT"
        rules={[{ required: true }]}
    >
        <Radio.Group>
            <Radio value="FULL PAYMENT">Full Payment</Radio>
            <Radio value="PART PAYMENT">Part Payment</Radio>
        </Radio.Group>
    </Form.Item>
</Col>
{selectedRMType === "IMPORT PAYABLE" && (
  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
    <Form.Item
      name="currency"
      label="Currency"
      rules={[{ required: true, message: 'Missing currency' }]}
    >
      <Select
        showSearch
        optionFilterProp="children"
        placeholder="Select Currency"
        allowClear
      >
        {currency.map(currencydropData => (
          <Option
            key={currencydropData.currencyId}
            value={currencydropData.currencyId}
          >
            {currencydropData.currencyName}
          </Option>
        ))}
      </Select>
    </Form.Item>
  </Col>
)}

<Col xs={24} sm={24} md={6} lg={6} xl={6}>
  <Form.Item
    name="payment"
    label={
      selectedRMType === "IMPORT PAYABLE"
        ? `Payment Amount (${
            currency.find(
              item =>
                item.currencyId ===
                paymentForm.getFieldValue('currency')
            )?.currencyName || ''
          })`
        : "Payment Amount (INR)"
    }
    rules={[
      { required: true, message: "Enter Payment" }
    ]}
  >
    <InputNumber
      style={{ width: '100%' }}
      min={0}
      onChange={(value) => calculateInvoiceAmount(value)}
    />
  </Form.Item>
</Col>

{selectedRMType === "IMPORT PAYABLE" && (
  <Col span={4}>
    <Form.Item
      name="exchangeRate"
      label="Exchange Rate"
    >
      <InputNumber
        style={{ width: '100%' }}
        min={0}
        onChange={(value) => {
          if (!value || value === 0) {
            paymentForm.setFieldsValue({
              exchangeRate: 1
            });
          }
          calculateInvoiceAmount();
        }}
      />
    </Form.Item>
  </Col>
)}
  {selectedRMType === "IMPORT PAYABLE" && (
                  <Col span={4}>
                    <Form.Item
                      name="receivedAmountInr"
                      label="Received Amount (INR)"
                    >
                      <InputNumber
                        disabled
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                  </Col>
  )}  
                  <Col span={6}>
                    <Form.Item
                      name="bankAccount"
                      label="Bank Account"
                    >
                      <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Select Bank Account"
                allowClear
              >
                {bankDetails.map(dropData => {
                  return <Option value={dropData.id} key={dropData.id}>{dropData.bankAcc }-{dropData.bankName}</Option>
                })}
              </Select>
                    </Form.Item>
                  </Col>
                  
                  <Col span={4}>
                    <Form.Item
                      name="bankCharges"
                      label="Bank Charges"
                    >
                      <InputNumber
                        style={{ width: '100%' }}
                        min={0}
                        onChange={() => {
                            calculateInvoiceAmount();
                            
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item
                      name="buyerShortPayment"
                      label="Buyer Short Payment"
                    >
                      <InputNumber
                        style={{ width: '100%' }}
                        min={0}
                        onChange={() => {
                          calculateInvoiceAmount();
                          
                      }}
                      />
                    </Form.Item>
                  </Col>
                  {(selectedRMType === "IMPORT PAYABLE" ||
  selectedRMType === "DOMESTIC") && (
                  <Col span={4}>
                    <Form.Item
                      name="invoiceAmount"
                      label="Invoice Amount"
                    >
                      <InputNumber
                        disabled
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                  </Col>
                  )}
                </>

              )}
        

        <Col span={8}>
            <Form.Item label="Remarks" name="remarks" >
                <Input.TextArea />
            </Form.Item>
        </Col>
    </>
)}
        </>
      )}
    </Row>
      
    <Row gutter={8} justify="center">
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
      {invoiceType=="PACKING" && (
       <Table
        columns={itemColumns}
        dataSource={itemsData}
        scroll={{ x: 'max-content' }}
        pagination={false}
        size="small"
        summary={(pageData) => {
          let totQuantity = 0;
          let totAmount = 0;
          let tax = 0;
          let payment = 0;
          let deductionAmount = 0;

          pageData.forEach(({ quantity,  deduction, discount,amount,type,taxPer,unitPrice,taxAmount }) => {
            totQuantity += parseFloat(quantity) || 0;
            if(invoiceType=='RM'){
            totAmount += parseFloat(amount) || 0;
              deductionAmount += type=='GOOD'?(deduction*0.001) : 0;
            }else{
              deductionAmount +=Number((deduction*0.001).toFixed(2));
              tax += Number(taxAmount)
              totAmount += (Number(amount)-Number(taxAmount) || 0)
            }
          });

          return (
            <Table.Summary.Row>
              <Table.Summary.Cell index={invoiceType=='RM'?7:5} colSpan={invoiceType=='RM'?7:5}>Total</Table.Summary.Cell>
              <Table.Summary.Cell index={invoiceType=='RM'?8:6}>{totQuantity.toFixed(2)}</Table.Summary.Cell>
              <Table.Summary.Cell index={invoiceType=='RM'?9:7}></Table.Summary.Cell>
              <Table.Summary.Cell index={invoiceType=='RM'?10:8}>{totAmount.toFixed(2)}</Table.Summary.Cell>
              {invoiceType!='RM'?(
                <><Table.Summary.Cell index={11}></Table.Summary.Cell>
                <Table.Summary.Cell index={12}></Table.Summary.Cell>
                <Table.Summary.Cell index={13}>{tax.toFixed(2)}</Table.Summary.Cell></>

                ):<></>}
              <Table.Summary.Cell index={invoiceType=='RM'?11:14}>{deductionAmount.toFixed(2)}</Table.Summary.Cell>
              <Table.Summary.Cell index={invoiceType=='RM'?12:15}>{((Number((totAmount).toFixed(2) )+ Number((tax).toFixed(2))- Number((deductionAmount).toFixed(2)))).toFixed(2)}</Table.Summary.Cell>
            </Table.Summary.Row>
          );
        }}
      />
      )}
      </Col>
    </Row>
    {invoiceType=="PACKING" && (
    <Row style={{justifyContent:'flex-end',marginLeft:'550px'}}>
       <Col span={12} >
      {data.length > 0 && (
          <Form.Item label= 'Payment' name='payment'
      rules={[
              {
                validator: (_, value) => {
                    if (Math.round(value) > Math.round(totalInvAmt-paidAmt)) {
                    return Promise.reject(
                      new Error(`Payment cannot exceed due amount `)
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <InputNumber
              min={0}
              step={0.01}
              style={{width:'200px'}} 
              onChange={handlePaymentChange}
              placeholder="Enter payment"
            />
      </Form.Item>

          )}
          </Col>
       <Col span={12} >
      {data.length > 0 && (
          <Form.Item label= 'Due Amount' name='due'
        style={{ margin: 0 }}>
        <InputNumber 
style={{width:'200px'}}
         disabled
        />
      </Form.Item>

          )}
          </Col>
    </Row>
    )}
        <Form.Item>
          {data.length > 0 && (
        <Button type="primary" htmlType="submit" style={{marginTop:20,float:'right'}}>
        Submit
        </Button>
          )}
        </Form.Item>
    </Form>    
  </Card>
</Modal>
</Card>
    </>
)
} 
export default Payables
